import GeneratedAuditLogServiceApi from "./generated/GeneratedAuditLogServiceApi"

class AuditLogServiceApi extends GeneratedAuditLogServiceApi {

}

export const auditLogServiceApi = new AuditLogServiceApi()
